<div class="people-instantsearch-wrapper">
  <div #searchBoxContainer></div>
  <div #hitsContainer></div>
</div>